// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__37K9q","content":"Consent_content__1K2Mz","footer":"Consent_footer__3PDjM"};